import React from 'react';
import ImageAppStore from '../../assets/images/app_store_badge_564x168.png';
import ImageGooglePlay from '../../assets/images/google_play_badge_trimmed_564x168.png';
import { STORE_LINKS } from '../../utils/platform';

const STORES = {
  ios: { href: STORE_LINKS.ios, img: ImageAppStore, alt: 'Download on the App Store' },
  android: { href: STORE_LINKS.android, img: ImageGooglePlay, alt: 'Get it on Google Play' },
};

const Badge = ({ store, height }) => (
  <a href={store.href} target="_blank" rel="noreferrer" style={{ display: 'inline-block', lineHeight: 0 }}>
    <img src={store.img} alt={store.alt} style={{ height, width: 'auto' }} />
  </a>
);

// On a phone, the visitor's own store is the prominent badge and the other is a
// smaller secondary badge. On desktop both badges are shown at equal weight.
const StoreBadges = ({ platform, align = 'center', height = 52 }) => {
  const justify = align === 'start' ? 'justify-content-start' : 'justify-content-center';

  if (platform === 'ios' || platform === 'android') {
    const primary = STORES[platform];
    const other = STORES[platform === 'ios' ? 'android' : 'ios'];
    return (
      <div className={`d-flex flex-column ${align === 'start' ? 'align-items-start' : 'align-items-center'}`} style={{ gap: 10 }}>
        <Badge store={primary} height={height} />
        <div className="d-flex align-items-center" style={{ gap: 8, opacity: 0.85 }}>
          <span className="text-muted small">Also on</span>
          <Badge store={other} height={Math.round(height * 0.6)} />
        </div>
      </div>
    );
  }

  return (
    <div className={`d-flex flex-wrap ${justify}`} style={{ gap: 12 }}>
      <Badge store={STORES.ios} height={height} />
      <Badge store={STORES.android} height={height} />
    </div>
  );
};

export default StoreBadges;
